import $ from 'jquery';

/**
 * Add following class names into corresponding address input field's wrapper (c-input)
 * '.js-search-address' - Google Places Search input
 * '.js-search-address-street' - Street Address
 * '.js-search-address-suburb' - Suburb
 * '.js-search-address-state' - State
 * '.js-search-address-postcode' - Postcode
 */

/**
 * To set input value according to its type
 * @param {String} type - Address component type from Google Place API
 * @param {String} detail - address componet detail
 */
const setAddressInput = (type, detail) => {
    const $street = $('.js-search-address-street input');
    const $suburb = $('.js-search-address-suburb input');
    const $state = $('.js-search-address-state select');
    const $postcode = $('.js-search-address-postcode input');

    switch (type) {
        case 'route':
            $street.val(detail);
            break;
        case 'locality':
            $suburb.val(detail);
            break;
        case 'administrative_area_level_1':
            $state.val(detail);
            break;
        case 'postal_code':
            $postcode.val(detail);
            break;
        default:
            break;
    }
};

/**
 * Resets value of address fields to ensure the address field is resetted
 * when the user change the address selection
 */
const resetAddressValues = () => {
    $('.js-search-address-street input').val('');
    $('.js-search-address-suburb input').val('');
    $('.js-search-address-state select').val('');
    $('.js-search-address-postcode input').val('');
};


/**
 * To clean possibly invalid/incompleted address info that user has typed in
 * when user decides to switch between manual and autocomplete
 */
const clearAddress = () => {
    resetAddressValues();
    $('.js-search-address input').val('');
};

/**
 * Google Places API
 */
const initAddressAutofill = () => {
    // Steps to initate Address Auto fill.
    const address = document.querySelector('.js-search-address input');
    const $addressFields = $('.js-search-address-field');
    // 1. Prep required address types from API response
    const componentForm = {
        street_number: 'short_name',
        route: 'short_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        postal_code: 'short_name'
    };

    $addressFields.addClass('sr-only');
    // 2. Create a new G address input
    // eslint-disable-next-line no-undef
    const autocomplete = new google.maps.places.Autocomplete(address, { componentRestrictions: { country: 'au' } });
    autocomplete.setFields(['address_component']);
    // workaround as browser autofill dropdown overlaps the actual google map address dropdown
    // eslint-disable-next-line no-undef
    google.maps.event.addDomListener(address, 'focus', e => e.target.setAttribute('autocomplete', 'new-password'));

    // 3. Handle when a user makes a selection.
    autocomplete.addListener('place_changed', () => {
        const curAddress = autocomplete.getPlace().address_components;
        let curStreet = '';
        resetAddressValues();
        for (let i = 0; i < curAddress.length; i += 1) {
            const curComponent = curAddress[i];
            const curComponentType = curComponent.types[0];
            const curDetail = curComponent[componentForm[curComponentType]];
            if (typeof curDetail !== 'undefined' && curDetail.length) {
                setAddressInput(curComponentType, curDetail);
                if (curComponentType === 'route') {
                    // save street for adding unit no/street no. down below.
                    curStreet = curDetail;
                }
            }
        }

        // 4. Handle Unit No./Street No. Google API doesn't have good support, so we'll help.
        const streetRegex = /(\d+[a-z]?\/\d+|\d+)/g;
        const unitAndStreetNo = address.value.match(streetRegex);
        if (unitAndStreetNo && unitAndStreetNo.length > 0) {
            const finalStreet = `${unitAndStreetNo.join('/')} ${curStreet}`;
            setAddressInput('route', finalStreet);
        }
    });
};

const initToggleManualAddressFields = () => {
    const $switchManualWrap = $('.js-search-address-manually');
    const $switchAutoWrap = $('.js-search-address-auto');
    const $allFieldsWrap = $('.js-search-address-field');

    $switchManualWrap.on('click tap touch', 'a', e => {
        e.preventDefault();
        $allFieldsWrap.slideUp('fast', () => {
            $allFieldsWrap.removeClass('sr-only').slideDown('fast');
        });
        $switchManualWrap.slideDown('fast').addClass('sr-only').slideUp(0); // to remove "display: none" from jQuery.slideUp();
        clearAddress();
    });

    $switchAutoWrap.on('click tap touch', 'a', e => {
        e.preventDefault();
        $switchManualWrap.removeClass('sr-only').slideDown(0);
        $allFieldsWrap.slideUp('fast', () => {
            $allFieldsWrap.addClass('sr-only').slideDown(0); // to remove "display: none" from jQuery.slideUp();
        });
        clearAddress();
    });
};

/**
 * Init all for address autofill
 */
const initAddressSearch = () => {
    const address = document.querySelector('.js-search-address input');
    if (address !== null) {
        initAddressAutofill();
        if (document.querySelector('.js-search-address-manually') !== null) {
            initToggleManualAddressFields();
        }
    }
};

export default initAddressSearch;



// WEBPACK FOOTER //
// ./src/components/form-elements/google-places.js